module.exports = __webpack_public_path__ + "media/images/web_suite/vb_suite_icon_75px-c0734905347f4bc5137512d7a3733abb.png";